import { useMemo, useState } from 'react';

interface IBooleanStateActions {
    toggle: () => void;
    set: (value: boolean) => void;
    setTrue: () => void;
    setFalse: () => void;
}

// Inspired by https://ahooks.js.org/hooks/use-boolean
export const useBoolean = (
    initialState: boolean | (() => boolean)
): [boolean, IBooleanStateActions] => {
    const [state, setState] = useState(initialState);
    const actions = useMemo<IBooleanStateActions>(() => {
        const toggle = () => setState((prevState) => !prevState);
        const setTrue = () => setState(true);
        const setFalse = () => setState(false);
        return { toggle, set: setState, setTrue, setFalse };
    }, []);

    return [state, actions];
};
